import * as React from 'react';
import { SVGType } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface INOOfficeBuildingIconProps extends SVGType {}

export const NOfficeBuildingIcon: React.FunctionComponent<INOOfficeBuildingIconProps> = ({
  stroke = '#1C1327',
  size = 20,
  ...rest
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 20 21" {...rest}>
      <g
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_2553_29689)"
      >
        <path d="M3.93 5.16v12.89m0 0h11.66m-11.66 0H2.26m1.67 0H8.1m7.5-4.67V4.72c0-.44-.18-.87-.49-1.18-.31-.31-.74-.49-1.18-.49H5.59m10.84 15h-5m0 0v-4.17c0-.22-.09-.43-.24-.59a.807.807 0 00-.59-.24H8.93c-.22 0-.43.09-.59.24-.16.16-.24.37-.24.59v4.17m3.33 0H8.1M7.87 6.38h.83M7.68 9.71h.83m2.92-3.33h.83m-.83 3.33h.83M17.55 19.15L1.75 2.75"></path>
      </g>
      <defs>
        <clipPath id="clip0_2553_29689">
          <path fill="#fff" d="M0 0H17.3V17.9H0z" transform="translate(1 2)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default NOfficeBuildingIcon;
